
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cz7bE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $biiXa = parcelRequire("biiXa");

var $29DUH = parcelRequire("29DUH");


var $6uGcC = parcelRequire("6uGcC");


var $4cOi8 = parcelRequire("4cOi8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");

const $11011ae26b5436e7$var$ENTRYPOINT_ID = 'deea6b68-cfd3-4fd1-b1d8-c857d919f9ad';
const $11011ae26b5436e7$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $11011ae26b5436e7$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    modalTitleSpecific: {
        id: "company-hub-utils.feedback-collector.title-specific",
        defaultMessage: "{type, select, Cards {We\u2019d love feedback on Cards} Carousel {We\u2019d love feedback on Carousel} Linksmenu {We\u2019d love feedback on Links menu} Spotlight {We\u2019d love feedback on Spotlight} Section {We\u2019d love feedback on Section} Companyhub {We\u2019d love feedback on Company hub} other {We\u2019d love feedback}}"
    },
    modalTitleGeneric: {
        id: "company-hub-utils.feedback-collector.title-generic",
        defaultMessage: "We\u2019d love feedback"
    },
    modalPreambleFirstLine: {
        id: "company-hub-utils.feedback-collector.preamble.first-line",
        defaultMessage: "Your input is valuable and allows Atlassian to better meet your needs. What about this feature could be improved?{lineBreak}"
    },
    modalSummaryPlaceholder: {
        id: "company-hub-utils.feedback-collector.summary-placeholder",
        defaultMessage: "What works well? What could be improved?"
    }
});
const $11011ae26b5436e7$var$FeedbackCollectorComponent = ({ flags: flags, onClose: onClose, onCloseComplete: onCloseComplete, source: source, type: type })=>{
    const intl = (0, $1cfRh.default)();
    const { displayName: displayName, userId: userId, locale: locale } = (0, $bQm3c.useSessionData)();
    const onSubmit = ()=>{
        flags.showFlag({
            customComponent: $11011ae26b5436e7$var$DismissibleFeedbackFlag
        });
        // Though AKFeedbackCollector uses modal-dialog internally, it doesn't expose its onCloseComplete callback. Since onCloseComplete is only necessary to avoid memory leaks, the delayed invocation of onSubmit fits the purpose.
        onCloseComplete?.();
    };
    // replacing whitespace from type is necessary, because there are FeedbackTypes that are whitespaced
    // i18n selects do not validate options with whitespace as in i18n.modalTitle above
    const feedbackTitle = type === (0, $4cOi8.FeedbackType).CUSTOMIZE_NAVIGATION ? intl.formatMessage($11011ae26b5436e7$export$a7357cdd1f0b0168.modalTitleGeneric) : intl.formatMessage($11011ae26b5436e7$export$a7357cdd1f0b0168.modalTitleSpecific, {
        type: type.replace(/\s/g, '')
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        locale: locale,
        onClose: onClose,
        onSubmit: onSubmit,
        atlassianAccountId: userId || '',
        name: displayName || '',
        entrypointId: $11011ae26b5436e7$var$ENTRYPOINT_ID,
        feedbackTitle: feedbackTitle,
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, intl.formatMessage($11011ae26b5436e7$export$a7357cdd1f0b0168.modalPreambleFirstLine, {
            lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null))
        })),
        summaryPlaceholder: intl.formatMessage($11011ae26b5436e7$export$a7357cdd1f0b0168.modalSummaryPlaceholder),
        additionalFields: [
            {
                id: $11011ae26b5436e7$var$FEEDBACK_CONTEXT_FIELD_ID,
                value: source
            }
        ]
    });
};
const $11011ae26b5436e7$export$fa63c8dd87ea8148 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
})((0, $7aRa9.withFlags)($11011ae26b5436e7$var$FeedbackCollectorComponent));
/**
 * Because `FeedbackFlag` does not accept an `id` prop, using it directly with `@confluence/flags` would result in an undismissible flag.
 */ function $11011ae26b5436e7$var$DismissibleFeedbackFlag({ id: id, onDismissed: onDismissed }) {
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(true);
    const onFlagGroupDismissed = (_, analyticsEvent)=>{
        setDisplayFlag(false);
        onDismissed?.(id, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: onFlagGroupDismissed
    }, displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $29DUH.default), null));
}
module.exports["i18n"] = $11011ae26b5436e7$export$a7357cdd1f0b0168;
module.exports["FeedbackCollector"] = $11011ae26b5436e7$export$fa63c8dd87ea8148;

});

parcelRegister("a1ePi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $7yOcR = parcelRequire("7yOcR");


var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $4cOi8 = parcelRequire("4cOi8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $lOeVN = parcelRequire("lOeVN");

const $394b15505d6b6fb9$var$i18n = (0, $h82at.defineMessages)({
    shareFeedbackButtonLabel: {
        id: "company-hub-utils.share-feedback-button.label",
        defaultMessage: "Share feedback on Company hub"
    }
});
const $394b15505d6b6fb9$var$layoutStyles = (0, $ecnYn.xcss)({
    position: 'fixed',
    margin: 'space.050',
    bottom: 'space.150'
});
const $394b15505d6b6fb9$var$leftPosition = (0, $ecnYn.xcss)({
    left: 'calc(space.150 + var(--leftSidebarWidth, 0px))'
});
const $394b15505d6b6fb9$var$buttonStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text',
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    display: 'flex',
    columnGap: 'space.050',
    alignItems: 'center',
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.overlay.pressed'
    }
});
const $394b15505d6b6fb9$export$b20a0f1dbbb60a2b = ()=>{
    const openFeedbackCollector = (0, $lOeVN.useFeedbackCollector)({
        source: 'companyHubViewPage',
        type: (0, $4cOi8.FeedbackType).COMPANY_HUB
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        testId: "layoutContainer",
        xcss: [
            $394b15505d6b6fb9$var$layoutStyles,
            $394b15505d6b6fb9$var$leftPosition
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $394b15505d6b6fb9$var$buttonStyles,
        onClick: openFeedbackCollector
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $394b15505d6b6fb9$var$i18n.shareFeedbackButtonLabel)));
};
const $394b15505d6b6fb9$var$ShareFeedbackButtonComponent = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($394b15505d6b6fb9$export$b20a0f1dbbb60a2b, null);
};
const $394b15505d6b6fb9$export$77f9f49f7a026f56 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
})($394b15505d6b6fb9$var$ShareFeedbackButtonComponent);
module.exports["ShareFeedbackButtonInner"] = $394b15505d6b6fb9$export$b20a0f1dbbb60a2b;
module.exports["ShareFeedbackButton"] = $394b15505d6b6fb9$export$77f9f49f7a026f56;

});


//# sourceMappingURL=FeedbackCollector.67308004.js.map
